<div class="card_color rounded-xl my-2 w-full py-6 px-4 text_white">
  <h2 class="text-md font-semibold mb-4 text-left ml-1">Categorias</h2>

  <!-- Lista del Menú -->
  <ul class="space-y-3">
    <li
      class="pb-2"
      *ngFor="let item of model; let i = index"
      (click)="goToCategory(item.routerLink)"
    >
      <a
        class="flex items-center px-2.5 text-sm font-normal text_white hover:text_black rounded-lg group button_color_customize hover:button_color_customize transition-all duration-200 py-3"
      >
        <app-menu-icons [iconLabel]="item.label"></app-menu-icons>
        <span class="ml-2 ease-in-out font-medium">{{ item.label }}</span>
      </a>
    </li>
  </ul>

  <div class="flex flex-wrap gap-2 pt-5 justify-center sm:justify-between">
    <div class="divide_y_customize divide_color_customize"></div>

    <app-social-links [social_networks]="social_networks"></app-social-links>
  </div>
</div>
